import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
    user: any | null;
    isAuthenticated: boolean;
}

const storedUser = localStorage.getItem('user');

const initialState: AuthState = {
    user: storedUser ? JSON.parse(storedUser) : null,
    isAuthenticated: !!storedUser,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login(state, { payload }) {
            state.user = payload;
            state.isAuthenticated = true;
            localStorage.setItem('user', JSON.stringify(payload));
        },
        logout(state) {
            state.user = null;
            state.isAuthenticated = false;
            localStorage.removeItem('user');
        },
        refresh(state, { payload }) {
            state.user = payload;
            localStorage.setItem('user', JSON.stringify(payload));
        },
    },
});

export const { login, logout, refresh } = authSlice.actions;
export default authSlice.reducer;
